if(!window._babelPolyfill){
	require("babel-polyfill");
}